module.exports = __webpack_public_path__ + "media/components/ImpactBlock/static/moneyhandgreen2-804044bd4e670c1332ac6972a8cdd5f1.jpg";